import axios from 'axios';
import { API_HOST } from '../../consts';

const createBoleto = (id) =>
  axios
    .post(`${API_HOST}/tickets/tickets/${id}/boleto`)
    .then((response) => response.data.boleto_id);

export default createBoleto;
